import { FC } from "react";
import { useTranslation } from "react-i18next";
import {ExtraGuestFeeIcon} from "src/assets/Icons";
import { formatNumber } from "src/utility";

interface ExtraGuestFeeWarningProps {
  extraGuestCharges: number;
  currency?: string;
}

const ExtraGuestFeeWarning: FC<ExtraGuestFeeWarningProps> = ({ extraGuestCharges, currency = "" }) => {
  const { t } = useTranslation();
  if (!extraGuestCharges || extraGuestCharges <= 0) return null;

  return (
    <div className="bg-background-warning text-font-warning flex items-center gap-2 rounded-sm p-3 text-xs">
      <ExtraGuestFeeIcon className="h-4 w-4 shrink-0" />
      <span>
        {t("Hotels.common.extraGuestFeeNotice", { amount: formatNumber(extraGuestCharges), currency })}
      </span>
    </div>
  );
};

export default ExtraGuestFeeWarning;